import { useState } from 'react';
import { useMount } from 'react-use';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/login/LoginForm';
import useLogin from '../hooks/useLogin';
import useExchangeTicket from '../hooks/useExchangeTicket';
import { useMediaQueryContext } from '../components/provider/MediaQueryProvider';
import LoginFormSP from '../components/login/LoginFormSP';
import styled from 'styled-components';

// 自動ログイン用のチケットをURLフラグメントから取り出す。
// フラグメントは form-encoded ではないため URLSearchParams は使わない(+ が空白に化ける)。
const readTicket = (): string | undefined => {
  const matched = /^#ticket=([^&]*)/.exec(window.location.hash)?.[1];
  if (matched == null) {
    return undefined;
  }
  try {
    return decodeURIComponent(matched);
  } catch {
    return undefined;
  }
};

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { isSpSite } = useMediaQueryContext();
  const { login, loading, errorMessage } = useLogin();
  const { exchangeTicket, errorMessage: exchangeErrorMessage } =
    useExchangeTicket();
  // チケット遷移では初期表示からローディングにする(フォーム操作とチケットの二重交換を防ぐ)
  const [exchanging, setExchanging] = useState(() => Boolean(readTicket()));

  // newegg からの自動ログイン。URLフラグメント(#ticket=...)の単回使用チケットを
  // /auth/exchange に送ってログインし、問題一覧へ遷移する。
  // hash は交換前に同期的にクリアする(履歴に残さない・二重実行での再交換を防ぐ)。
  // 失敗時(期限切れ・使用済み・通信エラー等)はエラーメッセージを出して手動ログインフォームに
  // フォールバックする。チケットを取り直すには newegg から入り直せばよいので再試行しない。
  useMount(() => {
    const ticket = readTicket();
    if (!ticket) {
      return;
    }
    window.history.replaceState(
      window.history.state,
      '',
      window.location.pathname + window.location.search,
    );
    exchangeTicket(ticket).then((result) => {
      if (result) {
        // ログイン画面を履歴に残さない(戻るとログイン済みなのにログインフォームが表示されるため)
        navigate('/', { replace: true });
      } else {
        setExchanging(false);
      }
    });
  });

  const handleSubmit = async (values: Record<string, any>) => {
    const result = await login(values);
    if (result) {
      navigate('/');
    }
  };
  const loginFormProps = {
    loading: loading || exchanging,
    errorMessage: errorMessage || exchangeErrorMessage,
    onFinish: handleSubmit,
  };

  return (
    <Container>
      {isSpSite ? (
        <LoginFormSP {...loginFormProps}></LoginFormSP>
      ) : (
        <LoginForm {...loginFormProps}></LoginForm>
      )}
    </Container>
  );
};

const Container = styled.div`
  margin: 5% auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default Login;
